/**
 * Page mot de passe oublié
 */

import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { authApi } from '@e-store/shared';
import './LoginPage.css';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);

    const response = await authApi.forgotPassword({ email });

    if (response.error) {
      setError(response.error);
      setIsSubmitting(false);
      return;
    }

    setSuccess(true);
    setIsSubmitting(false);
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <Link to="/login" className="back-link">&larr; Retour</Link>
          <h1>E-Store</h1>
          <h2>Mot de passe oublié</h2>
        </div>

        {success ? (
          <div style={{ textAlign: 'center' }}>
            <div className="success-message" style={{ background: '#dcfce7', color: '#16a34a', border: '1px solid #bbf7d0' }}>
              Un email de réinitialisation a été envoyé !
            </div>
            <p style={{ color: '#64748b', marginTop: '16px' }}>
              Veuillez consulter votre boîte mail pour réinitialiser votre mot de passe.
            </p>
            <p style={{ color: '#94a3b8', fontSize: '14px', marginTop: '8px' }}>
              N'oubliez pas de vérifier vos spams.
            </p>
          </div>
        ) : (
          <>
            {error && <div className="error-message">{error}</div>}

            <form onSubmit={handleSubmit} className="login-form">
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="votre@email.com"
                  required
                />
              </div>

              <button type="submit" className="btn-primary" disabled={isSubmitting}>
                {isSubmitting ? 'Envoi...' : 'Envoyer le lien'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
